export const ADMIN_BASE = '/admin';
export const INVITE_BASE = '/invite';
export const basePath = () => (window.location.pathname.startsWith(INVITE_BASE) ? INVITE_BASE : ADMIN_BASE);
export const homeFor = (user) => {
  if (!user) return `${ADMIN_BASE}/login`;
  if (user.role === 'super_admin') return ADMIN_BASE;
  if (user.role === 'guest') return `${INVITE_BASE}/portail`;
  return INVITE_BASE;
};
export const loginFor = (user) => (user?.role === 'super_admin' ? `${ADMIN_BASE}/login` : `${INVITE_BASE}/login`);
export const hasPerm = (user, perm) => {
  if (!perm || !user) return !perm;
  if (user.role === 'super_admin' || user.role === 'manager' || user.role === 'viewer') return true;
  return (user.permissions || []).includes(perm);
};
